import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DetailVpsComponent from "../../../components/Customer/vps/DetailVpsComponent";

const DetailVpsPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <DetailVpsComponent
        vpsId={ params.vpsId }
        redirectBack={ () => redirectBack() }
    />;
}

export default DetailVpsPage;